// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import axios from 'axios'
import qs from 'qs'
import wx from 'weixin-js-sdk'
import common from './Common/common'
import api from './Common/api'
import util from './Common/util'
//Vuejs 单页应用在iOS系统下部分APP的webview中 标题不能通过 document.title = xxx 的方式修改 该插件只为解决该问题而生(兼容安卓)
import VueWechatTitle from 'vue-wechat-title'
import getBankCardInfo from 'bankcardinfo'
/*import { Message } from 'element-ui'*/
/*import 'element-ui/lib/theme-chalk/index.css'*/
import BaiDuMap from 'vue-baidu-map'
import VueECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/dataZoom'
import Toast from '@nutui/nutui/dist/packages/toast/toast.js'
import '@nutui/nutui/dist/packages/toast/toast.css'
import NarBar from '@nutui/nutui/dist/packages/navbar/navbar.js'
import '@nutui/nutui/dist/packages/navbar/navbar.css'
import Tabbar from '@nutui/nutui/dist/packages/tabbar/tabbar.js'
import '@nutui/nutui/dist/packages/tabbar/tabbar.css'
import Price from '@nutui/nutui/dist/packages/price/price'
import '@nutui/nutui/dist/packages/price/price.css'
import Row from '@nutui/nutui/dist/packages/row/row'
import '@nutui/nutui/dist/packages/row/row.css'
import Col from '@nutui/nutui/dist/packages/col/col'
import '@nutui/nutui/dist/packages/col/col.css'
import TabPanel from '@nutui/nutui/dist/packages/tabpanel/tabpanel'
import '@nutui/nutui/dist/packages/tabpanel/tabpanel.css'
import Tab from '@nutui/nutui/dist/packages/tab/tab'
import '@nutui/nutui/dist/packages/tab/tab.css'
import Cell from '@nutui/nutui/dist/packages/cell/cell'
import '@nutui/nutui/dist/packages/cell/cell.css'
import Icon from '@nutui/nutui/dist/packages/icon/icon'
import '@nutui/nutui/dist/packages/icon/icon.css'
import SearchBar from '@nutui/nutui/dist/packages/searchbar/searchbar'
import '@nutui/nutui/dist/packages/searchbar/searchbar.css'
import Radio from '@nutui/nutui/dist/packages/radio/radio'
import '@nutui/nutui/dist/packages/radio/radio.css'
import RadioGroup from '@nutui/nutui/dist/packages/radiogroup/radiogroup'
import '@nutui/nutui/dist/packages/radiogroup/radiogroup.css'
import Popup from '@nutui/nutui/dist/packages/popup/popup'
import '@nutui/nutui/dist/packages/popup/popup.css'
import Menu from '@nutui/nutui/dist/packages/menu/menu'
import '@nutui/nutui/dist/packages/menu/menu.css'
import Switch from '@nutui/nutui/dist/packages/switch/switch'
import '@nutui/nutui/dist/packages/switch/switch.css'
import ButtonGroup from '@nutui/nutui/dist/packages/buttongroup/buttongroup'
import '@nutui/nutui/dist/packages/buttongroup/buttongroup.css'
import Button from '@nutui/nutui/dist/packages/button/button'
import '@nutui/nutui/dist/packages/button/button.css'
import Dialog from '@nutui/nutui/dist/packages/dialog/dialog'
import '@nutui/nutui/dist/packages/dialog/dialog.css'
import TextInput from '@nutui/nutui/dist/packages/textinput/textinput'
import '@nutui/nutui/dist/packages/textinput'
import TextBox from '@nutui/nutui/dist/packages/textbox/textbox'
import '@nutui/nutui/dist/packages/textbox/textbox.css'
import InfiniteLoading from '@nutui/nutui/dist/packages/infiniteloading/infiniteloading'
import '@nutui/nutui/dist/packages/infiniteloading/infiniteloading.css'
import Checkbox from '@nutui/nutui/dist/packages/checkbox/checkbox'
import '@nutui/nutui/dist/packages/checkbox/checkbox.css'
import Address from '@nutui/nutui/dist/packages/address/address'
import '@nutui/nutui/dist/packages/address/address.css'
import BackTop from '@nutui/nutui/dist/packages/backtop/backtop'
import '@nutui/nutui/dist/packages/backtop/backtop.css'
import Picker from '@nutui/nutui/dist/packages/picker/picker'
import '@nutui/nutui/dist/packages/picker/picker.css'
import Calendar from '@nutui/nutui/dist/packages/calendar/calendar'
import '@nutui/nutui/dist/packages/calendar/calendar.css'
import ActionSheet from '@nutui/nutui/dist/packages/actionsheet/actionsheet'
import '@nutui/nutui/dist/packages/actionsheet/actionsheet.css'
import Avatar from '@nutui/nutui/dist/packages/avatar/avatar'
import '@nutui/nutui/dist/packages/avatar/avatar.css'
import Scroller from '@nutui/nutui/dist/packages/scroller/scroller'
import '@nutui/nutui/dist/packages/scroller/scroller.css'
import Drag from '@nutui/nutui/dist/packages/drag/drag'
import '@nutui/nutui/dist/packages/drag/drag.css'
import ImagePicker from '@nutui/nutui/dist/packages/imagepicker/imagepicker'
import '@nutui/nutui/dist/packages/imagepicker/imagepicker.css'
import NoticeBar from '@nutui/nutui/dist/packages/noticebar/noticebar'
import '@nutui/nutui/dist/packages/noticebar/noticebar.css'

import NBar from './components/common/comp/NBar'
import MTab from './components/common/comp/MTab'
import NoData from './components/common/comp/NoData'
import MList from './components/common/comp/MList'
import ListLoading from './components/common/comp/ListLoading'
import Pay from './components/device/common/Pay'

Vue.prototype.$getBankCardInfo = getBankCardInfo

Pay.install(Vue)
Toast.install(Vue)
NarBar.install(Vue)
Tabbar.install(Vue)
Price.install(Vue)
Row.install(Vue)
Col.install(Vue)
TabPanel.install(Vue)
Tab.install(Vue)
Cell.install(Vue)
Icon.install(Vue)
SearchBar.install(Vue)
Radio.install(Vue)
RadioGroup.install(Vue)
Popup.install(Vue)
Menu.install(Vue)
Switch.install(Vue)
ButtonGroup.install(Vue)
Button.install(Vue)
Dialog.install(Vue)
TextInput.install(Vue)
TextBox.install(Vue)
InfiniteLoading.install(Vue)
Checkbox.install(Vue)
Address.install(Vue)
BackTop.install(Vue)
Picker.install(Vue)
Calendar.install(Vue)
ActionSheet.install(Vue)
Avatar.install(Vue)
Scroller.install(Vue)
ImagePicker.install(Vue)
NoticeBar.install(Vue)
Drag.install(Vue)

MTab.install(Vue)
NBar.install(Vue)
NoData.install(Vue)
MList.install(Vue)
ListLoading.install(Vue)
const mApi = api.init(Vue)
Vue.component('v-chart', VueECharts)
//将第三方插件挂载到原型上
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$wx = wx

Vue.prototype.$common = common
Vue.prototype.$util = util

Vue.use(VueWechatTitle)
Vue.use(BaiDuMap, {
  ak: 'QnGa0l3G7YVtb5rftbdVetYtHKEbgWva'
})
Vue.config.productionTip = false
axios.defaults.baseURL = '/merchant'
//axios.defaults.baseURL = process.env.MAPI_HOST;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

/**
 * 监听路由跳转前事件
 */
router.beforeEach((to, from, next) => {
  let mLogin = to.meta.login
  let back = to.meta.back
  if (back == null) {
    back = false
  }
  if (mLogin == null) {
    mLogin = true
  }
  if (to.query) {
    let { access_token, token_type, subscribe, merId, login = mLogin } = to.query
    if (access_token && token_type) {
      localStorage.setItem('access_token', token_type + ' ' + access_token)
      localStorage.setItem('subscribe', subscribe)
    }
    if (merId) {
      mApi.merId = merId
      localStorage.setItem('merId', merId)
    }
    if (to.path == '/device/DeviceUse' && util.isArrOrNull(mApi.merId)) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
    }
    access_token = localStorage.getItem('access_token')
    if (access_token) {
      next()
    } else {
      if (back) {
        next()
      } else {
        if (to.path == '/device/DeviceUse' && (from.path == '/device/DeviceUse' || from.fullPath == '/')) {
          let ua = window.navigator.userAgent.toLowerCase()
          //判断是不是微信
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            localStorage.setItem('webType', 'weixin')
          }
          //判断是不是支付宝
          if (ua.match(/AlipayClient/i) == 'alipayclient') {
            localStorage.setItem('webType', 'alipay')
          }
          api.getDevice({ path: to.path, query: to.query, fullPath: to.fullPath })
        } else {
          localStorage.removeItem('webType')
          login ? next('/device/login') : next()
        }
      }
    }
  } else {
    !mLogin ? next() : null
  }
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})




// WEBPACK FOOTER //
// ./src/main.js